/**
 * Override BodygenUtils.lockScroll / unlockScroll so the mobile menu
 * only uses overflow:hidden instead of position:fixed on body.
 * Prevents the "everything jumps" effect when opening the menu.
 */
(function () {
  function applyOverride() {
    if (typeof window.BodygenUtils === "undefined") return;
    window.BodygenUtils.lockScroll = function () {
      document.body.style.overflow = "hidden";
    };
    window.BodygenUtils.unlockScroll = function () {
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");
      document.body.style.removeProperty("width");
    };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyOverride);
  } else {
    applyOverride();
  }
  // Fallback: apply after a short delay in case bx.js loads later (defer)
  setTimeout(applyOverride, 100);
})();
